import React from "react";

const FinsireButton = ({ icon: Icon, text }) => {
  return (
    <button className="w-full flex items-center py-[3px] px-[14px] text-white rounded-[5px] bg-[#00394D] h-[32px] cursor-pointer">
      <span className="hidden lg:flex lg:items-center">
        <Icon className="w-[20px] h-[18px] text-white" />
        <span
          className="ml-1 text-sm font-semibold leading-6"
          aria-hidden="true"
        >
          {text}
        </span>
      </span>
    </button>
  );
};

export default FinsireButton;
